# import BillFragment from "../fragments/bill.graphql"

query BillsQuery($company_id: ID!) {
  bills(company_id: $company_id) {
    ...BillFragment
  }
}
